module.exports = __webpack_public_path__ + "static/img/yy1.b854587.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/yy1.png
// module id = 4JKK
// module chunks = 1